<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_PROCESANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOPLANCARGO.LBL_PLANCARGO' | translate }}">
    <form
      [formGroup]="formulario"
      (ngSubmit)="onSubmit()"
      novalidate
      id="fFormulario"
      name="nomFormulario"
    >
      <div class="grid form-group align-items-center">
        <div class="col-12 md:col-3 lg:col-3 pt-0">
          <div class="div-form">
            <label>* {{ 'FORMADESEMBOLSO.LBL_TIPOESPECIE' | translate }}</label>
            <p-dropdown disableTab  id="idEspecie" name="nomEspecie" [options]="lisFormaDesembolso"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idFormaDesembolso"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFormaDesembolso.invalid">
              {{ 'FORMADESEMBOLSO.LBL_TIPOESPECIE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3 pt-0">
          <div class="div-form">
            <label>* {{ "PRODUCTOPLANCARGO.LBL_PLANCARGO" | translate }}</label>
            <div>
              <p-dropdown disableTab
                id="idPlanCargo"
                name="nomConceptoFacturacion"
                [options]="lisPlanesCargos"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
                filter="true"
                formControlName="idPlanCargo"
              ></p-dropdown>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idPlanCargo.invalid"
              >
                {{ "PRODUCTOPLANCARGO.LBL_PLANCARGO" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-2 lg:col-2" class="align-center">
          <div class="div-form">
            <p-checkbox
              label="{{ 'PRODUCTOPLANCARGO.LBL_INDICADIGITAL' | translate }}"
              binary="true"
              id="idIndicadorDigital"
              name="nomIndicadorDigital"
              formControlName="indicadorDigital"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-2 lg:col-2" class="align-center">
          <div class="div-form">
            <p-checkbox
              label="{{ 'PRODUCTOPLANCARGO.LBL_INDICATRADICIONAL' | translate }}"
              binary="true"
              id="idIndicadorTradicional"
              name="nomIndicadorTradicional"
              formControlName="indicadorTradicional"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-2 lg:col-2" class="align-center">
          <div class="div-form">
            <p-checkbox
              label="{{
                'PRODUCTOPLANCARGO.LBL_INDICAPREDETERMINADO' | translate
              }}"
              binary="true"
              id="idIndicadorDefault"
              name="nomIndicadorDefault"
              formControlName="indicadorDefault"
            ></p-checkbox>
          </div>
        </div>
      </div>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <a
              (click)="regresarFormulario(formulario.dirty)"
              class="cancelar"
              >{{ "BTN_CANCELAR" | translate }}</a
            >
            <button
              icon="fa fa-plus"
              label="{{ 'BTN_GUARDAR' | translate }}"
              type="submit"
              pButton
            ></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
            <span>{{ "LBL_GUARDANDO" | translate }}</span>
          </div>
        </div>
      </div>
    </form>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table
          [columns]="columnas"
          [loading]="carTabla"
          [value]="lisProductoPlanesCargos"
          selectionMode="single"
          dataKey="idProductoPlanesCargos"
          [paginator]="true"
          [rows]="10"

          paginatorPosition="bottom"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                *ngFor="let col of columns"
                [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="!col.sort"
                class="text-center"
              >
                {{ col.header }}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{ row.formaDesembolso }}</td>
              <td>{{ row.planCargo }}</td>
              <td class="text-center">
                <p-checkbox
                  binary="true"
                  id="indicadorDigital"
                  name="indicadorDigital"
                  [(ngModel)]="row.indicadorDigital"
                  (onChange)="habilitarInhabilitar(row, $event, 'indicadorDigital')"
                  [disabled]="esDetalle"
                ></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox
                  binary="true"
                  id="indicadorTradicional"
                  name="indicadorTradicional"
                  [(ngModel)]="row.indicadorTradicional"
                  (onChange)="habilitarInhabilitar(row, $event, 'indicadorTradicional')"
                  [disabled]="esDetalle"
                ></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox
                  binary="true"
                  id="indicadorDefault"
                  name="indicadorDefault"
                  [(ngModel)]="row.indicadorDefault"
                  (onChange)="habilitarInhabilitar(row, $event, 'indicadorDefault')"
                  [disabled]="esDetalle"
                ></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button
                    type="button"
                    class="p-button p-button-success btn"
                    icon="fa fa-trash"
                    data-toggle="tooltip"
                    title="{{ 'BTN_ELIMINAR' | translate }}"
                    pButton
                    (click)="habilitarInhabilitar(row, null, null, false)"
                  ></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ "MSG_NOHAYREGISTROS" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>

<p-confirmDialog #cg key="planes-cargos">
  <ng-template pTemplate="footer">
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cg.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cg.accept()"
    ></button>
  </ng-template>
</p-confirmDialog>
